import { forwardRef, type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  flush?: boolean;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ flush, className, children, ...rest }, ref) => {
    return (
      <div
        ref={ref}
        data-rail-card
        className={cn(
          'rounded-lg border border-border bg-card',
          !flush && 'p-3',
          className,
        )}
        {...rest}
      >
        {children}
      </div>
    );
  },
);
Card.displayName = 'Card';
